import { ITask } from 'bom/types';
import { mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { IRequestPayload } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';

export const getTasksAutocomplete = async (
  requestPayload?: IRequestPayload,
  signal?: AbortSignal
) => {
  const { data } = await partfinitiClient.get(
    `/bom/task-list/tasks?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<ITask>(data.data, data.recordsFiltered);
};
